import { defineStore } from 'pinia'

export const useStatusStore = defineStore('status', {
    state: () => ({
        historyLength: 0,
    }),
    actions: {
        setHistoryLength(length) {
            this.historyLength = length
        },
    },
})
